/**
 * Плагин: при удалении edge с графа удаляем связь из модели и шлём patch removeConnection.
 * При размонтировании редактора подписка снимается до detach(), поэтому события от очистки графа не уходят в сокет.
 */
import * as connectionModel from '../modelerX6/ConnectionModel';

export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onEdgeRemoved = args => {
			if (modeler._applyingPatch) return;
			if (modeler._removingConnectionId != null) return;
			const cell = args?.edge ?? args?.cell;
			if (!cell) return;
			const id = typeof cell === 'string' ? cell : cell?.id;
			if (!id) return;
			if (modeler.isLockedByOther?.(id)) return;
			const viewElement = modeler._findViewElementById(id);
			if (!viewElement || !viewElement.relationshipRef) return;
			connectionModel.removeConnection(modeler, id);
			onPatch({
				patches: [{op: 'removeConnection', viewIndex: VIEW_INDEX, identifier: id}],
			});
		};

		graph.on('edge:removed', onEdgeRemoved);

		return () => graph.off('edge:removed', onEdgeRemoved);
	},
};
